import SearchRoadRoutingRequest, {
  SearchRoadRoutingRequestWaypointCoordinate,
} from "../../../utils/search-road-route/search-road-routing.request";
import DelegationRoadRouteParams, {
  DelegationRoadRouteParamsWaypoint,
} from "./delegation-road-route-params";

const changeWaypointType = (
  type: DelegationRoadRouteParamsWaypoint,
): SearchRoadRoutingRequestWaypointCoordinate => {
  return {
    latitude: type.lat,
    longitude: type.lon,
  };
};

const create = (
  loadParams: DelegationRoadRouteParams,
): SearchRoadRoutingRequest => {
  return {
    waypointCoordinates: loadParams.waypoints.map(changeWaypointType),
  };
};

const delegationRoadRouteParamsFactory = {
  create,
};

export default delegationRoadRouteParamsFactory;
